import { MouseEvent, useCallback, useEffect, useState } from "react";
import { TooltipProps, useMediaQuery, useTheme } from "@mui/material";

export const useTooltipOnTap = (title: string) => {
  const theme = useTheme();
  const isTouchLayout = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);
  const hasTitle = Boolean(title);

  useEffect(() => {
    setOpen(false);
  }, [title]);

  const handleWrapperClick = useCallback(
    (event: MouseEvent) => {
      if (!hasTitle) return;

      event.preventDefault();
      event.stopPropagation();
      setOpen((prev) => !prev);
    },
    [hasTitle],
  );

  if (!hasTitle) {
    return {
      tooltipProps: {},
      handleWrapperClick: () => undefined,
      showTapHint: false,
    };
  }

  const tooltipProps: Partial<TooltipProps> = {
    open,
    onOpen: () => setOpen(true),
    onClose: () => setOpen(false),
    disableHoverListener: isTouchLayout,
    disableFocusListener: isTouchLayout,
    disableTouchListener: true,
  };

  return {
    tooltipProps,
    handleWrapperClick,
    showTapHint: true,
  };
};
